export default __webpack_public_path__ + "static/media/deliveryCar.92922d5a.svg";